//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      dialogVisible: false,
      isAgree: false,
      form: {
        order_id: '',
        real_name: '',
        user_phone: '',
        refund_reason: '',
        pay_price: ''
      }
    };
  },
  created: function created() {},
  methods: {
    show: function show(agree, row, finish) {
      this.dialogVisible = true;
      this.isAgree = agree;
      this.finish = finish;
      console.log('row', row);
      this.form = this.$tempModel.deepCopy(row);
    },
    clear: function clear() {
      this.dialogVisible = false;
      this.finish = null;
    },
    clickCancel: function clickCancel() {
      this.clear();
    },
    clickSubmit: function clickSubmit() {
      if (this.finish) {
        this.finish(this.form);
      }

      this.clear();
    }
  }
};